import {
  TStudentPrimary,
  TStudentDetailsSimplified,
} from '../apis/students/students.interfaces';
import { TStaffResponse } from '../apis/staff/staff.interfaces';
import {
  TAttendanceByDateResponse,
  TAttendanceByDateRecord,
} from '../apis/__shared/attendance.interfaces';
import { TUserDetailsSimplifiedObject } from '../apis/users/users.interfaces';

export const simplifiedStudentUserListToMap = (
  userList: TStudentPrimary[]
): Record<string, TStudentDetailsSimplified> => {
  return userList.reduce(
    (acc, user) => {
      acc[user.id] = {
        id: user.id,
        basicDetails: user.basicDetails,
        grade: user.grade,
        section: user.section,
      };
      return acc;
    },
    {} as Record<string, TStudentDetailsSimplified>
  );
};

export const simpliefiedStaffListToMap = (
  userList: TStaffResponse[]
): Record<string, TStudentDetailsSimplified> => {
  return userList.reduce(
    (acc, user) => {
      acc[user.id] = {
        id: user.id,
        basicDetails: user.basicDetails,
      };
      return acc;
    },
    {} as Record<string, TStudentDetailsSimplified>
  );
};

export const extractStaffFromAttendanceRecords = (
  attendanceRecords: TAttendanceByDateResponse
): TUserDetailsSimplifiedObject => {
  const staffMap: TUserDetailsSimplifiedObject = {};

  // Normalize to array-based structure: Array<{ date: string; records: TAttendanceRecord[] }>
  // Supports both array format (new) and object format (legacy)
  const recordsArray: Array<{
    date: string;
    records: TAttendanceByDateRecord[];
  }> = Array.isArray(attendanceRecords)
    ? attendanceRecords
    : Object.entries(attendanceRecords).map(([date, records]) => ({
        date,
        records,
      }));

  recordsArray.forEach(({ records }) => {
    records.forEach((record: TAttendanceByDateRecord) => {
      const userId = record.userDetails.id;
      if (userId && record.userDetails && !staffMap[userId]) {
        staffMap[userId] = {
          id: userId,
          basicDetails: record.userDetails,
        };
      }
    });
  });

  return staffMap;
};

export const formatDateForSubmit = (date: number | Date): string => {
  if (typeof date === 'number') {
    return new Date(date).toISOString().split('T')[0];
  }
  return date.toISOString().split('T')[0];
};
